import { getFormattedCountryName } from "~/lib/helpers/constants";
import { useRegionConfig } from "~/store/regionConfigStore";

export type OfficeType = 'Private' | 'Shared' | 'Coworking' | 'Virtual' | 'Sublet' | 'Temp' | string;

const { regionConfig } = useRegionConfig.getState();

interface OfficeTypeInfo {
    label: string;
    spaceType: string;
}

export const OFFICE_TYPE_LABEL: Record<OfficeType, OfficeTypeInfo> = {
    OfficeSpace: { label: 'Office Space', spaceType: 'Office Space' },
    Private: { label: "Lockable Private Office", spaceType: "Private Office" },
    'Private Office Space': { label: "Lockable Private Office", spaceType: "Private Office" },
    Shared: { label: "Desk in a Shared Space", spaceType: "Shared Office" },
    'Shared Office Space': { label: "Desk in a Shared Space", spaceType: "Shared Office" },
    Coworking: { label: "Coworking Desk", spaceType: "Coworking Space" },
    Virtual: { label: "Virtual Office", spaceType: "Virtual Office" },
    Sublet: { label: "Private Sublet Office Space", spaceType: "Sublet Office" },
    'Part Time Desk Space': { label: "Desk in a Shared Space", spaceType: "P/Time Desk" },
    'P/Time Desk': { label: "Desk in a Shared Space", spaceType: "P/Time Desk" },
    Temp: { label: "Private / Shared Temporary Workspace", spaceType: "Temp Desk" },
    Canvas: { label: "Canvas", spaceType: "Canvas" },
    'Sublet Office': { label: "Private Sublet Office Space", spaceType: "Sublet Office" },
    'Virtual Office': { label: "Virtual Office", spaceType: "Virtual Office" },
    Enterprise: { label: "Enterprise Space", spaceType: "Enterprise Space" },
    'Enterprise Suite': { label: "Enterprise Space", spaceType: "Enterprise Space" },
    Managed: { label: "Managed Space", spaceType: "Managed Space" }
} as const;

interface OfficeListing {
    id: string;
    location: string;
    address: string;
    capacity: string;
    fullAddress: string;
}
export const NearOffices: OfficeListing[] = [
    {
        id: "1",
        location: "Kent Street, Sydney",
        address: "207 Kent Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at 207 Kent Street, Sydney",
    },
    {
        id: "2",
        location: "Cliff Street, Milsons Point",
        address: "Cliff Street, Milsons Point, Sydney",
        capacity: "15 Person",
        fullAddress:
            "15 Person Managed Space at Cliff Street, Milsons Point, Sydney",
    },
    {
        id: "3",
        location: "Miller Street, North Sydney",
        address: "50 Miller Street, North Sydney",
        capacity: "19 Person",
        fullAddress: "19 Person Managed Space at 50 Miller Street, North Sydney",
    },
    {
        id: "4",
        location: "Kents Street, Sydney",
        address: "207 Kents Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed space at 207 Kents Street, Sydney",
    },
    {
        id: "5",
        location: "Castlereagh Street, Sydney",
        address: "Castlereagh Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at Castlereagh Street, Sydney",
    },
    {
        id: "6",
        location: "George Street, Sydney",
        address: "580 George Street, Sydney",
        capacity: "16 Person",
        fullAddress: "16 Person Managed Space at 580 George Street, Sydney",
    },
    {
        id: "7",
        location: "Sussex Street, Sydney",
        address: "201 Sussex Street, Sydney",
        capacity: "16 Person",
        fullAddress: "16 Person Managed Space at 201 Sussex Street, Sydney",
    },
    {
        id: "8",
        location: "George Street, Sydney",
        address: "580 George Street Sydney",
        capacity: "16 Person",
        fullAddress: "16 Person Managed space at 580 George Street Sydney",
    },
    {
        id: "9",
        location: "George Street, Sydney",
        address: "580 George Street Sydney",
        capacity: "11 Person",
        fullAddress: "11 Person Managed space at 580 George Street Sydney",
    },
    {
        id: "10",
        location: "George Street, Sydney",
        address: "580 George Street, Sydney",
        capacity: "16 Person",
        fullAddress: "16 Person Managed Space at 580 George Street, Sydney",
    },
    {
        id: "11",
        location: "Castlereagh Street, Sydney",
        address: "Castlereagh Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at Castlereagh Street, Sydney",
    },
    {
        id: "12",
        location: "George Street, Sydney",
        address: "George Street, Sydney",
        capacity: "16 Person",
        fullAddress: "16 Person Managed Space at George Street, Sydney",
    },
    {
        id: "13",
        location: "Castlereagh Street, Sydney",
        address: "Castlereagh Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at Castlereagh Street, Sydney",
    },
    {
        id: "14",
        location: "Castlereagh Street, Sydney",
        address: "Castlereagh Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at Castlereagh Street, Sydney",
    },
    {
        id: "15",
        location: "Castlereagh Street, Sydney",
        address: "Castlereagh Street, Sydney",
        capacity: "15 Person",
        fullAddress: "15 Person Managed Space at Castlereagh Street, Sydney",
    },
    {
        id: "16",
        location: "New South Head Road, EdgeCliff",
        address: "New South Head Road, EdgeCliff, Sydney",
        capacity: "16 Person",
        fullAddress:
            "16 Person Managed Space at New South Head Road, EdgeCliff, Sydney",
    },
    {
        id: "17",
        location: "George Street, Sydney",
        address: "264 George Street, Sydney",
        capacity: "18 Person",
        fullAddress: "18 Person Managed Space at 264 George Street, Sydney",
    },
    {
        id: "18",
        location: "George Street, Sydney",
        address: "264 George Street, Sydney",
        capacity: "18 Person",
        fullAddress: "18 Person managed Space at 264 George Street, Sydney",
    },
    {
        id: "19",
        location: "New South Head Road, EdgeCliff",
        address: "New South Head Road, EdgeCliff, Sydney",
        capacity: "16 Person",
        fullAddress:
            "16 Person Managed Space at New South Head Road, EdgeCliff, Sydney",
    },
    {
        id: "20",
        location: "New South Head Road, EdgeCliff",
        address: "New South Head Road, EdgeCliff, Sydney",
        capacity: "16 Person",
        fullAddress:
            "16 Person Managed Space at New South Head Road, EdgeCliff, Sydney",
    },
];
export const TRANSPORT_LABELS = {
    bus: "Buses",
    ferry: "Ferry",
    train: "Trains",
    airport: "Airports",
    bar: "Bars",
    cafe: "Cafes",
    taxi: "Taxis",
    gym: "Gyms",
}
// export const workspaceOptions = [
// let { regionConfig } = require("~/store/regionConfigStore").useRegionConfig.getState();
export const workspaceOptions = [
    {
        title: "Serviced Office",
        description:
            "Fully managed offices with everything ready to move in.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/managed.avif`,
        features: [
            "Move-in ready spaces",
            "High-speed internet and utilities included",
            "On-site reception and admin services",
            "Daily maintenance and cleaning",
        ],
        link: "office-space/serviced-offices",
        // spaceType: "managed"
    },
    {
        title: "Coworking Office",
        description:
            "Connect, collaborate, and grow in shared creative spaces.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/coworking.avif`,
        features: [
            "Ideal for freelancers and startups",
            "Access to shared amenities and events",
            "Flexible membership plans",
            `Available across ${getFormattedCountryName(regionConfig?.region)}`,
        ],
        link: "office-space/coworking-space",
        spaceType: "coworking"
    },
    {
        title: "Private Office",
        description:
            "Secure, furnished offices designed for focus and privacy.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/private.avif`,
        features: [
            "Fully enclosed, lockable offices",
            "Ready-to-use with furniture and internet",
            "Access to shared amenities",
            "Ideal for 2–50 people",
        ],
        link: "office-space/private-offices",
        spaceType: "private"
    },
    {
        title: "Shared Office",
        description:
            "Work alongside other professionals in a social setting.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/shared.avif`,
        features: [
            "Cost-effective for small teams",
            "Modern design and shared meeting rooms",
            "Great networking opportunities",
            "Flexible lease options",
        ],
        link: "office-space/shared-offices",
        spaceType: "shared"
    },
    {
        title: "Enterprise Office",
        description:
            "Tailored workspaces for large and growing business teams.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/enterprise.avif`,
        features: [
            "Dedicated floors or suites",
            "Branding and fit-out flexibility",
            "24/7 access and support staff",
            "Perfect for cooperates and expanding companies",
        ],
        link: "office-space/enterprise-office-space",
        spaceType: "enterprise"
    },
    {
        title: "Sublease Office",
        description:
            "Short-term office rentals ideal for agile business needs.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/sublet.avif`,
        features: [
            "Fully fitted offices available immediately",
            "Flexible lease terms",
            "Great for project-based teams",
            "Lower upfront costs",
        ],
        link: "office-space/conventional-sublet-offices",
        spaceType: "sublet"
    },
    {
        title: "Hot Desk Space",
        description:
            "Flexible desks available daily in dynamic shared offices.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/hot-desk.avif`,
        features: [
            "Flexible daily or monthly plans",
            "Networking with diverse professionals",
            "Access to all coworking facilities",
            "Pay only for the days you use",
        ],
        link: "office-space/hot-desk",
        spaceType: "coworking"
    },
    {
        title: "Virtual Office",
        description:
            "Get a business address and admin support without the space.",
        image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/virtual.avif`,
        features: [
            "Professional business address",
            "Mail and call handling",
            "Access to meeting rooms on demand",
            "Perfect for remote teams and startups",
        ],
        link: "office-space/virtual-office",
        spaceType: "virtual"
    },
];

/**
 * Canonical region for each state/sub-region slug used in search URLs.
 *
 * Add a new country by appending an entry here — e.g. `us: ["ny", "ca", ...]`.
 * The reverse lookup below is derived automatically, so callers only need to
 * `STATE_SLUG_TO_REGION.get(slug)` to resolve a slug's region in O(1).
 */
export const REGION_STATE_SLUGS: Record<string, readonly string[]> = {
    uk: ["england", "scotland", "wales", "northern-ireland"],
    au: ["nsw", "vic", "qld", "sa", "tas", "act", "nt"],
};

export const STATE_SLUG_TO_REGION: ReadonlyMap<string, string> = new Map(
    Object.entries(REGION_STATE_SLUGS).flatMap(([region, slugs]) =>
        slugs.map((slug) => [slug, region] as const),
    ),
);
